import { Component, OnInit } from '@angular/core';
import { InputComponent } from '../../components/input/input';
import { Loading } from '../../components/loading/loading';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { AdminService } from '../../services/admin-service';
import { DataPicker } from '../../components/data-picker/data-picker';
import { Select } from '../../components/select/select';

@Component({
  selector: 'app-mqtt-monitor',
  imports: [InputComponent, Loading, FormsModule, NgClass, DataPicker, ReactiveFormsModule, Select],
  templateUrl: './mqtt-monitor.html',
  styleUrl: './mqtt-monitor.scss',
})
export class MqttMonitor implements OnInit {
  rangeData: [Date, Date] = [new Date(), new Date()];
  loading = false;
  filterText = '';
  filteredConnections: any[] = [];
  connections: any[] = [];
  sortDirection: 'asc' | 'desc' = 'desc';
  type = new FormControl<'connected' | 'disconnected' | 'authorization'>('connected');
  typeOptions = [
    { label: 'Conexões', value: 'connected' },
    { label: 'Desconexões', value: 'disconnected' },
    { label: 'Erros', value: 'authorization' },
  ];

  constructor(private adminService: AdminService) {
    this.type.valueChanges.subscribe((value) => {
      this.getLogs();
    });
  }

  ngOnInit(): void {
    this.rangeData[0].setHours(0);
    this.rangeData[1].setHours(23);
    this.rangeData[0].setDate(this.rangeData[0].getDate() - 1);

    this.getLogs();
  }

  onRangeChanged(value: [Date, Date]) {
    this.rangeData = value;
    this.getLogs();
  }

  applyFilter() {
    const search = this.filterText.toLowerCase();
    this.filteredConnections = this.connections.filter(
      (connection) =>
        connection.message.toLowerCase().includes(search) ||
        connection.logStreamName.toLowerCase().includes(search)
    );
  }

  toggleSort() {
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    const direction = this.sortDirection === 'asc' ? 1 : -1;
    this.filteredConnections.sort((a, b) => (a.timestamp - b.timestamp) * direction);
  }

  formatDate(timestamp: number): string {
    return new Date(timestamp).toLocaleString();
  }

  getMessageClass(message: string): string {
    if (message.toLowerCase().includes('disconnected')) return 'text-yellow-600';
    if (message.toLowerCase().includes('connected')) return 'text-green-600 font-semibold';
    return 'text-red-600';
  }

  getLogs() {
    this.loading = true;
    this.adminService
      .getMqttLogs(this.rangeData[0], this.rangeData[1], this.type.value!)
      .subscribe((resp) => {
        this.connections = [...resp];
        this.filteredConnections = [...resp];
        this.loading = false;
      });
  }

  formatJson(json: any): string {
    try {
      // Se vier como string compacta, vira objeto
      const obj = typeof json === 'string' ? JSON.parse(json) : json;

      // Se já estiver formatado, apenas retorna formatado
      return JSON.stringify(obj, null, 2);
    } catch {
      // Se não der parse, retorna o próprio valor
      return json;
    }
  }
}
